// One role=status message for a list's results and paging: 500 ms
// debounce, cleared before writing, last event wins. A copy of the
// announcer in routes/ObservacionesDelProyectoRoute.tsx (the postventa
// route stays untouched).

import { useCallback, useEffect, useRef, useState } from "react";

export function useListAnnouncer() {
  const [msg, setMsg] = useState("");
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);
  useEffect(
    () => () => {
      if (timer.current) clearTimeout(timer.current);
    },
    []
  );
  const announce = useCallback((m: string) => {
    setMsg("");
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(() => setMsg(m), 500);
  }, []);
  return [msg, announce] as const;
}
